class a {
  async getCustomerProfile(e) {
    return this.getProfile(e);
  }
  async getProfile(e) {
    const t = "https://profile.cimpress.io/v1/ozoDdrmewShEcbUDWX8J3V/profile/me";
    try {
      const r = await fetch(t, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: e
        }
      });
      if (!r.ok) {
        if (r.status === 403)
          return {};
        throw new Error(`HTTP ${r.status}: ${r.statusText}`);
      }
      return await r.json() || {};
    } catch (r) {
      const o = r instanceof Error ? r.message : "Unknown error";
      return console.error("Error occurred while getting customer profile", {
        url: t,
        message: "Error occurred while getting customer profile",
        error: o
      }), {};
    }
  }
}
export {
  a as default
};
//# sourceMappingURL=contact-channels18.js.map
